import React, { useState, ChangeEvent, useEffect } from 'react';

interface CheckBoxesProps {
    options?: string[],
    values?: string[],
    onValueChange?: (value: string[]) => void;
    getFriendlyNameForOptions: (value: string) => string;
    isDisabled?: boolean;
    disabledValues?: string[];
}

const CheckBoxes: React.FC<CheckBoxesProps> = ({ values, options, onValueChange, getFriendlyNameForOptions, isDisabled, disabledValues }) => {
    const [checkBoxValues, setCheckBoxValues] = useState(values || []);

    const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        const selectedValue = event.target.value;
        let updatedValues;

        if (checkBoxValues.includes(selectedValue)) {
            updatedValues = checkBoxValues.filter((value) => value !== selectedValue);
        } else {
            updatedValues = [...checkBoxValues, selectedValue];
        }

        updatedValues = updatedValues.filter((value) => !disabledValues?.includes(value));
        setCheckBoxValues(updatedValues);

        if (onValueChange) {
            onValueChange(updatedValues);
        }
    };

    const isInputDisabled = (value: string) => {
        return isDisabled || (disabledValues && disabledValues.includes(value));
    };

    return (
        <div className="checkbox-question">
            {
                options?.map((value, key) =>
                <div className="checkbox" key={key}>
                    <label>
                            <input disabled={isInputDisabled(value)} type="checkbox" value={value} onChange={handleInputChange} checked={checkBoxValues.includes(value)} />{getFriendlyNameForOptions(value)}
                    </label>
                </div>)
            }
        </div>
    )
}

export default CheckBoxes;
